export class VerificationModel {
  verificationCode: string;
  constructor() {
    this.verificationCode = '';
  }
}
